import { FC } from "react";
import { Modal } from "@vilocnv/allsetra-core";
import { Box, Chip, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  onClose: () => void;
  alertName: string;
  objectNames: string[];
};

const MaintenanceAlertObjectsListModal: FC<Props> = ({
  open,
  onClose,
  alertName,
  objectNames
}) => {
  const theme = useTheme();
  const { t } = useTranslation("translation");

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("maintenanceAlerts.objectsListTitleWithName", {
        name: alertName || t("maintenanceAlerts.unnamedAlertFallback")
      })}
      theme={theme}
      size="customSize"
      hideFooter
    >
      <Box
        sx={{
          maxHeight: "min(420px, 55vh)",
          overflowY: "auto",
          overflowX: "hidden",
          pr: 0.5
        }}
      >
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {objectNames.map((objectName, index) => (
            <Chip
              key={`${objectName}-${index}`}
              label={objectName}
              size="small"
            />
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};

export default MaintenanceAlertObjectsListModal;
